import Confirmation from './Confirmation-view';

export default Confirmation;
